import { useFeatureFlag } from '../shared/feature-flags/useFeatureFlag';
import { CheckoutMedia } from './CheckoutMedia';

export function CheckoutBannerVideo({ src }: { src: string }) {
  const enabled = useFeatureFlag('checkoutBannerVideo');
  if (!enabled) return null;

  try {
    const url = new URL(src);
    if (url.protocol !== 'http:' && url.protocol !== 'https:') return null;
  } catch {
    return null;
  }

  return (
    <div className="vp-checkout-banner" data-testid="checkout-banner-video">
      <CheckoutMedia src={src} className="vp-checkout-banner-player" title="Vídeo do checkout" />
    </div>
  );
}
